import { Model } from "./model";
import { PaymentOption } from "./payment_option";

export class SavingsPaymentAccountModel extends Model {
	private label: string = "";
	private payment_option: PaymentOption = new PaymentOption();
	private sepa_mandate_id: string = "";

	public getPaymentOption(): PaymentOption {
		return this.payment_option;
	}

	public getLabel(): string {
		return this.label;
	}

	public getSepaMandateId(): string {
		return this.sepa_mandate_id;
	}
}
